export default __webpack_public_path__ + "static/media/Saibaba9.714fa81e.jpg";